var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-switch",class:{ disabled: _vm.disabled }},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.modelValue},on:{"input":_vm.onInput}}),_c('span',{staticClass:"slider"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }